export default __webpack_public_path__ + "static/media/Add-credit-card@2x.ba60df62.png";